import React from "react";

import Navigation from "../../v2components/element/Navigation/Navigation";

const Header = () => (
  <div>
    <Navigation maxWidth={'1130px'} isVersionTwo={true} />
  </div>
);

export default Header;

// import React, { Component } from "react";
// import Link from "gatsby-link";

// import SignUp from "../../components/Buttons/SignUp";
// import pageLinks from "libs/pageLinks";

// import yocoLogo from "../../images/yocoLogo.svg";
// import DropDownMenu from "./dropDownMenu";
// import capital from "../../images/products-icons/nav_logo_capital@2x.png"; // TODO: Needs a 2x version.
// import integrations from "../../images/products-icons/nav_icon_integrations@2x.png";
// import card_payments from "../../images/products-icons/nav_icon_card@2x.png";
// import business_portal from "../../images/products-icons/nav_icon_portal@2x.png";
// import accessories from "../../images/products-icons/nav_icon_accessories@2x.png";
// import pos from "../../images/products-icons/nav_icon_pos@2x.png";
// import JustStart from "./images/juststart.png";
// import mobileMenuIcon from "./images/mobileMenuIcon.svg";

// class Header extends Component {
//   constructor(props) {
//     super(props);
//     this.state = {
//       productMenuOpen: false,
//       companyMenu: false,
//       mobileMenuOpen: false
//     };
//   }

//   toggleMenu() {
//     this.setState({
//       mobileMenuOpen: !this.state.mobileMenuOpen
//     });
//   }

//   openClass() {
//     return this.state.mobileMenuOpen ? "mobileMenuOpen" : "";
//   }
//   componentDidMount() {
//     window.addEventListener("resize", this.handleResize);
//   }

//   componentWillUnmount() {
//     window.removeEventListener("resize", this.handleResize);
//   }

//   handleResize = () => {
//     this.forceUpdate();
//   };

//   pageSizing = (
//     heightsize = "472px",
//     overflow = "auto",
//     borderbot = "",
//     mobile = ""
//   ) => {
//     if (typeof window !== `undefined`) {
//       heightsize = window.innerHeight >= 472 ? heightsize : "90vh";
//       overflow = window.innerWidth >= 991 ? "" : overflow;
//       heightsize = window.innerWidth >= 991 ? "" : heightsize;
//       borderbot =
//         window.innerWidth >= 991 ? borderbot : "0 2px 0 0 rgba(0, 0, 0, .1)";
//       mobile =
//         window.innerWidth >= 991 ? styles.fullscreen : styles.menuListItems;
//     }
//     return { heightsize, overflow, borderbot, mobile };
//   };

//   render() {
//     const { heightsize, overflow, borderbot, mobile } = this.pageSizing();

//     return (
//       <div>
//         <div className="header">
//           <div className="container">
//             {/* Home */}
//             <Link to="/za/">
//               <img
//                 className={"headerLogo"}
//                 src={yocoLogo}
//                 style={{ height: "47px" }}
//               />
//             </Link>
//             <SignUp
//               className="mobileHeaderBtn"
//               text="SIGN UP"
//               link="/create-account/v1"
//             />
//             <div
//               className={`menuHolder ${this.openClass()}`}
//               style={{ boxShadow: borderbot }}
//             >
//               {/* window.innerHeight */}
//               <ul
//                 style={{
//                   height: heightsize,
//                   overflow: overflow
//                 }}
//               >
//                 {/* Drop Down Menu */}
//                 <DropDownMenu title="products">
//                   <Link to="/za/credit-card-readers">
//                     <li style={styles.menuListItems}>
//                       <img src={card_payments} style={styles.icon} />
//                       <span
//                         style={
//                           this.props.tabName == "credit-card-readers"
//                             ? { color: "#2DA0DB" }
//                             : {}
//                         }
//                       >
//                         Card Payments
//                       </span>
//                       <p>Accept card payments and grow your business.</p>
//                     </li>
//                   </Link>

//                   <Link to="/za/point-of-sale-app">
//                     <li style={styles.menuListItems}>
//                       <img src={pos} style={styles.icon} />
//                       <span
//                         style={
//                           this.props.tabName == "point-of-sale-app"
//                             ? { color: "#2DA0DB" }
//                             : {}
//                         }
//                       >
//                         Point of Sale
//                       </span>
//                       <p>
//                         Process card payments, manage your stock and track
//                         sales.
//                       </p>
//                     </li>
//                   </Link>

//                   <Link to="/za/portal">
//                     <li style={styles.menuListItems}>
//                       <img src={business_portal} style={styles.icon} />
//                       <span
//                         style={
//                           this.props.tabName == "portal"
//                             ? { color: "#2DA0DB" }
//                             : {}
//                         }
//                       >
//                         Business Portal
//                       </span>
//                       <p>
//                         Dynamic business insights in the cloud, at your
//                         fingertips
//                       </p>
//                     </li>
//                   </Link>

//                   <Link to="/za/capital">
//                     <li style={styles.menuListItems}>
//                       <img src={capital} style={styles.capitalIcon} />
//                       <span
//                         style={
//                           this.props.tabName == "capital"
//                             ? { color: "#2DA0DB" }
//                             : {}
//                         }
//                       >
//                         Capital
//                       </span>
//                       <p>
//                         Get quick access to business finance to help you grow.
//                       </p>
//                     </li>
//                   </Link>

//                   <Link to="/za/integrations/">
//                     <li style={styles.menuListItems}>
//                       <img src={integrations} style={styles.icon} />
//                       <span
//                         style={
//                           this.props.tabName == "integrations"
//                             ? { color: "#2DA0DB" }
//                             : {}
//                         }
//                       >
//                         Integrations
//                       </span>
//                       <p>
//                         Integrations for your Payments, Point of Sale and
//                         Accounting.
//                       </p>
//                     </li>
//                   </Link>

//                   <a href="https://yoco.store/" target="_blank">
//                     <li style={styles.menuListItems}>
//                       <img src={accessories} style={styles.icon} />
//                       Accessories
//                       <p>Make smart sales with a range of POS accessories</p>
//                     </li>
//                   </a>
//                 </DropDownMenu>

//                 {/* Line menu Items */}
//                 <li>
//                   <Link to="/za/transaction-fees">
//                     <span
//                       style={
//                         this.props.tabName == "transaction-fees"
//                           ? { color: "#2DA0DB" }
//                           : {}
//                       }
//                     >
//                       Pricing
//                     </span>
//                   </Link>
//                 </li>

//                 <DropDownMenu title="company" className={"smallWidth"}>
//                   <Link to="/za/about/">
//                     {" "}
//                     <li style={mobile}>
//                       <span
//                         style={
//                           this.props.tabName == "about"
//                             ? { color: "#2DA0DB" }
//                             : {}
//                         }
//                       >
//                         About Us
//                       </span>
//                     </li>
//                   </Link>
//                   <a href="/blog">
//                     <li style={mobile}>Blog</li>
//                   </a>
//                   <Link to="/za/press">
//                     <li style={mobile}>
//                       <span
//                         style={
//                           this.props.tabName == "press"
//                             ? { color: "#2DA0DB" }
//                             : {}
//                         }
//                       >
//                         Media Room
//                       </span>
//                     </li>
//                   </Link>
//                   <Link to="/za/careers/">
//                     <li style={mobile}>
//                       <span
//                         style={
//                           this.props.tabName == "careers"
//                             ? { color: "#2DA0DB" }
//                             : {}
//                         }
//                       >
//                         Careers
//                       </span>
//                     </li>
//                   </Link>
//                   <Link to="/za/stories">
//                     <li style={mobile}>
//                       <span
//                         style={
//                           this.props.tabName == "stories"
//                             ? { color: "#2DA0DB" }
//                             : {}
//                         }
//                       >
//                         Stories
//                       </span>
//                     </li>
//                   </Link>
//                 </DropDownMenu>
//                 <li>
//                   <a href={pageLinks.FAQ}>SUPPORT</a>
//                 </li>
//                 <Link to={pageLinks.CONTACT_PAGE}>
//                   <li>Contact</li>
//                 </Link>
//                 <li>
//                   <a href="https://portal.yoco.co.za/" target="_blank">
//                     LOGIN
//                   </a>
//                 </li>
//                 <li>
//                   <SignUp
//                     className={"headerBtn"}
//                     text="SIGN UP"
//                     link="/create-account/v1"
//                   />
//                 </li>
//               </ul>
//             </div>
//             <div className={"mobileMenuIcon"} onClick={() => this.toggleMenu()}>
//               <img src={mobileMenuIcon} />
//             </div>
//           </div>
//         </div>
//       </div>
//     );
//   }
// }

// const styles = {
//   icons: {
//     width: 35,
//     marginLeft: 5
//   },
//   capitalIcon: {
//     height: "100%",
//     width: 35,
//     marginLeft: 8,
//     marginRight: 32
//   },
//   menuListItems: {
//     paddingTop: 0,
//     paddingBottom: 0
//   },
//   fullscreen: {}
// };

// export default Header;



// WEBPACK FOOTER //
// ./src/components/Header/index.js